module.exports = __webpack_public_path__ + "static/media/top-millionaires-dark-icon.c595d4e7.svg";